import React, { forwardRef } from 'react'
import { usePagination, useUsedCarsData } from '../../hooks'
import FindVehicleResultsCount from './find-vehicle-results-count.component'

const FindVehicleResultsCountContainer: React.ForwardRefRenderFunction<
  HTMLSpanElement
> = (_, ref) => {
  const { isLoading, searchResults } = useUsedCarsData()

  const searchResultsCount =
    searchResults?.hybridSearchResultCount ?? searchResults?.searchResultsCount

  const [{ pageItemsRange }] = usePagination(
    searchResults?.pageNumber || 0,
    searchResults?.pageSize || 0,
    searchResults?.searchResultsCount || 0,
  )

  return (
    <FindVehicleResultsCount
      searchResultsCount={searchResultsCount || 0}
      pageItemsRange={pageItemsRange}
      fetchStatus={isLoading}
      ref={ref}
    />
  )
}

export const FindVehicleResultsCountWrapper = forwardRef(
  FindVehicleResultsCountContainer,
)
